module.exports = __webpack_public_path__ + "static/img/human.957ddea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/human.png
// module id = kbIk
// module chunks = 1